import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../user/user.service';
import { filter, map, take } from 'rxjs/operators';

export const dineInGuard: CanActivateFn = (route, state) => {
   const userService = inject(UserService);
   const router = inject(Router);

   return userService.currentStore$.pipe(
      filter((store) => store !== null),
      take(1),
      map((store) => {
         if (store?.enableDineIn === false) {
            router.navigate(['/dashboard']);
            return false;
         }
         return true;
      }),
   );
};
